<template>
  
  <div class="p-4 md:p-6 shadow">
            
            <div class="flex" :class="showFormSection ? 'cursor-pointer' : 'cursor-default'" @click="showSection()"  >
                    <div>
                        <div
                            class="rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium"
                            :class="[formComplete ? ['bg-white'] : ['bg-light-blue', 'text-white']]"
                        >1</div>
                    </div>
                    <div
                        class="ml-4"
                        :class="formComplete ? 'text-white' : ''"
                    >
                        <p class="text-lg sm:text-2xl font-medium leading-none xs:leading-tight">Datos del vehículo</p>
                        <p class="text-sm leading-tight mt-1 xs:mt-0">Precio y plazos seleccionados.</p>
                    </div>
                    <div class="ml-auto mt-2">
                        <div
                            v-if="!formComplete"
                            :key="showFormSection"
                            :class="showFormSection ? 'triangle-up-black' : 'triangle-down-black'"
                        ></div>
                        <div
                            v-else
                            :class="showFormSection ? 'triangle-up-white' : 'triangle-down-white'"
                        ></div>
                    </div>
            </div>

            
            <!-- Content goes here -->
            <div v-if="showFormSection" class="pt-5">
                <div class="flex flex-col">
                        <span>Vehiculo Seleccionado: {{model_power_train.name  }}  </span>
                        <span>Enganche: $49,280.00 M.X.N </span>
                        <span>Precio total del vehículo: ${{model_power_train.price}} M.X.N </span>
                        <span>Plazo: 12 meses </span>
                </div>
                
                
                
                

            </div>
</div>

</template>

<script>
export default {

    data(){
        return{
            url: $(".url").text(),
            showFormSection:true,
            formComplete:false,
            currentForm:true,
            model_power_train:[]
            
            
        }
    },
    mounted(){
        axios.get(`${this.url}/abcChargeVehicle`)
            .then((res)=>{
                this.model_power_train = res.data.powerTrain

            })

    },

    methods:{
        showSection(){
            this.showFormSection = !this.showFormSection
        }
    },

}
</script>

<style>

</style>